import { useState, useEffect } from "react";
import { useSettingsSection } from "@/lib/useSettingsSection";
import { PageTitle, Card, Field, inputCls, SaveButton } from "@/components/admin/ui";

export default function AdminContact() {
  const { settings, saving, save } = useSettingsSection();
  const [c, setC] = useState({});
  useEffect(() => { if (settings) setC(settings.contact || {}); }, [settings]);
  if (!settings) return <div className="text-slate-400">Loading…</div>;
  const set = (k) => (e) => setC({ ...c, [k]: e.target.value });

  return (
    <div data-testid="admin-contact">
      <PageTitle title="Contact Information" subtitle="These details appear across the website. Keep them accurate." />
      <Card>
        <div className="grid sm:grid-cols-2 gap-x-6">
          <Field label="Advocate Name"><input className={inputCls} value={c.name || ""} onChange={set("name")} data-testid="contact-name-input" /></Field>
          <Field label="Designation"><input className={inputCls} value={c.designation || ""} onChange={set("designation")} /></Field>
        </div>
        <Field label="Office Address"><textarea rows={3} className={inputCls} value={c.address || ""} onChange={set("address")} data-testid="contact-address-input" /></Field>
        <div className="grid sm:grid-cols-2 gap-x-6">
          <Field label="Phone Number 1"><input className={inputCls} value={c.phone1 || ""} onChange={set("phone1")} data-testid="contact-phone1-input" /></Field>
          <Field label="Phone Number 2"><input className={inputCls} value={c.phone2 || ""} onChange={set("phone2")} data-testid="contact-phone2-input" /></Field>
        </div>
        <div className="grid sm:grid-cols-2 gap-x-6">
          <Field label="Email" hint="Use [Add Official Email Address] until a real email is available."><input className={inputCls} value={c.email || ""} onChange={set("email")} data-testid="contact-email-input" /></Field>
          <Field label="Office Hours"><input className={inputCls} value={c.office_hours || ""} onChange={set("office_hours")} /></Field>
        </div>
        <div className="grid sm:grid-cols-2 gap-x-6">
          <Field label="WhatsApp Number" hint="Optional. Shows a WhatsApp button if set."><input className={inputCls} value={c.whatsapp || ""} onChange={set("whatsapp")} /></Field>
        </div>
        <Field label="Google Maps Embed URL" hint="Paste the src URL from a Google Maps 'Embed a map' iframe."><input className={inputCls} value={c.map_url || ""} onChange={set("map_url")} data-testid="contact-map-input" /></Field>
        <SaveButton onClick={() => save({ contact: c })} saving={saving} testid="save-contact" />
      </Card>
    </div>
  );
}
